import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { LoadingContent } from '../../../components'
import PdcaLayout from '../base/pdcaLayout'
import PdcaPageHeader from '../components/pdcapageheader/pdcapageheader'
import PdcaEmptyState from '../components/pdcaemptystate/pdcaemptystate'
import PdcaPlanoCard from '../components/pdcaplanocard/pdcaplanocard'
import Detalheplano from '../detalheplano/detalheplano'
import RejeitarPlano from '../rejeitarplano/rejeitarplano'
import AprovarAcao from '../aprovaracao/aprovaracao'
import Aprovarplanoplan from '../aprovarplanoplan/aprovarplanoplan'
import Agiract from '../agiract/agiract'
import { fetchPriorities, clearPriorities } from './redux/prioritiesactions'
import './priorities.scss'

const obterAcoesPriorities = (
  item,
  nls,
  podeGerirProjeto,
  handleAbrirRejeitar,
  handleAbrirAprovarPlan,
  handleAbrirAprovarDo
) => {
  const cicloAtual = (item?.ciclo || '').toLowerCase()

  if (cicloAtual === 'plan') {
    const actions = [
      { key: 'details', label: nls.actionDetails, primary: false }
    ]

    if (podeGerirProjeto) {
      actions.unshift(
        {
          key: 'approve',
          label: nls.actionApprove,
          primary: true,
          onClick: () => handleAbrirAprovarPlan(item)
        },
        {
          key: 'reject',
          label: nls.actionReject,
          primary: false,
          onClick: () => handleAbrirRejeitar(item)
        }
      )
    }

    return actions
  }

  if (cicloAtual === 'do') {
    const actions = [
      { key: 'details', label: nls.actionDetails, primary: false }
    ]

    if (podeGerirProjeto) {
      actions.unshift(
        {
          key: 'approve',
          label: nls.actionApprove,
          primary: true,
          onClick: () => handleAbrirAprovarDo(item)
        },
        {
          key: 'reject',
          label: nls.actionReject,
          primary: false,
          onClick: () => handleAbrirRejeitar(item)
        }
      )
    }

    return actions
  }

  if (cicloAtual === 'check') {
    const actions = [
      { key: 'details', label: nls.actionDetails, primary: false }
    ]

    if (podeGerirProjeto) {
      actions.unshift({
        key: 'reject',
        label: nls.actionReject,
        primary: false,
        onClick: () => handleAbrirRejeitar(item)
      })
    }

    return actions
  }

  if (cicloAtual === 'act') {
    const actions = [
      { key: 'details', label: nls.actionDetails, primary: false }
    ]

    if (podeGerirProjeto) {
      actions.unshift(
        { key: 'act', label: nls.actionAct, primary: true }
      )
    }

    return actions
  }

  return [
    { key: 'details', label: nls.actionDetails, primary: false }
  ]
}

export default () => {
  const dispatch = useDispatch()
  const { idProjetos } = useParams()

  const { sistema, projeto } = useSelector(state => state.layoutState)
  const nls = require(`./nls/${sistema.idioma}.json`)

  const { empresaPdcaExiste, contextoCarregado } = useSelector(
    state => state.pdcaState.pdcaBaseState
  )

  const {
    itens = [],
    total = 0,
    loading = false,
    error = null
  } = useSelector(state => state.pdcaState.pdcaPrioritiesState || {})

  const [detalheOpen, setDetalheOpen] = useState(false)
  const [planoIdSelecionado, setPlanoIdSelecionado] = useState(null)

  const [rejeitarOpen, setRejeitarOpen] = useState(false)
  const [planoIdRejeitar, setPlanoIdRejeitar] = useState(null)
  const [nomePlanoRejeitar, setNomePlanoRejeitar] = useState('')
  const [cicloRejeitar, setCicloRejeitar] = useState('')

  const [aprovarOpen, setAprovarOpen] = useState(false)
  const [planoIdAprovar, setPlanoIdAprovar] = useState(null)
  const [nomePlanoAprovar, setNomePlanoAprovar] = useState('')

  const [aprovarPlanOpen, setAprovarPlanOpen] = useState(false)
  const [planoIdAprovarPlan, setPlanoIdAprovarPlan] = useState(null)

  const [agirActOpen, setAgirActOpen] = useState(false)
  const [planoIdAgirAct, setPlanoIdAgirAct] = useState(null)

  const podeGerirProjeto = projeto?.permissaoPdcaGerirProjeto === true

  useEffect(() => {
    if (!idProjetos) {
      return undefined
    }

    dispatch(fetchPriorities(idProjetos))

    return () => {
      dispatch(clearPriorities())
    }
  }, [dispatch, idProjetos])

  const handleDetalhes = planoId => {
    if (!planoId) {
      return
    }

    setPlanoIdSelecionado(planoId)
    setDetalheOpen(true)
  }

  const handleAbrirRejeitar = item => {
    if (!item?.pdca_plano_id || !item?.ciclo) {
      return
    }

    setPlanoIdRejeitar(item.pdca_plano_id)
    setCicloRejeitar((item.ciclo || '').toLowerCase())
    setNomePlanoRejeitar(`${nls.planNumber} ${item.numero_plano} - ${item.titulo}`)
    setRejeitarOpen(true)
  }

  const handleFecharRejeitar = () => {
    setRejeitarOpen(false)
    setPlanoIdRejeitar(null)
    setNomePlanoRejeitar('')
    setCicloRejeitar('')
  }

  const handleSucessoRejeitar = () => {
    handleFecharRejeitar()
    dispatch(fetchPriorities(idProjetos))
  }

  const handleAbrirAprovarDo = item => {
    if (!item?.pdca_plano_id) {
      return
    }

    setPlanoIdAprovar(item.pdca_plano_id)
    setNomePlanoAprovar(`${nls.planNumber} ${item.numero_plano} - ${item.titulo}`)
    setAprovarOpen(true)
  }

  const handleFecharAprovar = () => {
    setAprovarOpen(false)
    setPlanoIdAprovar(null)
    setNomePlanoAprovar('')
  }

  const handleSucessoAprovar = () => {
    handleFecharAprovar()
    dispatch(fetchPriorities(idProjetos))
  }

  const handleAbrirAprovarPlan = item => {
    if (!item?.pdca_plano_id) {
      return
    }

    setPlanoIdAprovarPlan(item.pdca_plano_id)
    setAprovarPlanOpen(true)
  }

  const handleFecharAprovarPlan = () => {
    setAprovarPlanOpen(false)
    setPlanoIdAprovarPlan(null)
  }

  const handleSucessoAprovarPlan = () => {
    handleFecharAprovarPlan()
    dispatch(fetchPriorities(idProjetos))
  }

  const handleAgirAct = planoId => {
    if (!planoId) {
      return
    }

    setPlanoIdAgirAct(planoId)
    setAgirActOpen(true)
  }

  const handleSucessoAgirAct = () => {
    setAgirActOpen(false)
    setPlanoIdAgirAct(null)
    dispatch(fetchPriorities(idProjetos))
  }

  const contextoInconsistente = contextoCarregado && !empresaPdcaExiste
  const subtitle = `${total} ${total === 1 ? nls.summaryItemSingular : nls.summaryItemPlural}`

  return (
    <PdcaLayout>
      <div className='box-pdca-priorities'>
        <PdcaPageHeader
          title={nls.pageTitle}
          subtitle={subtitle}
        />

        {contextoInconsistente ? (
          <div className='box-pdca-priorities-inline-error'>
            {nls.contextError}
          </div>
        ) : null}

        {!contextoInconsistente ? (
          <LoadingContent loading={loading}>
            {error ? (
              <div className='box-pdca-priorities-inline-error'>
                {nls.loadError}
              </div>
            ) : null}

            {!error ? (
              <>
                {itens.length ? (
                  <div className='box-pdca-priorities-list'>
                    {itens.map(item => (
                      <PdcaPlanoCard
                        key={`${item.grupoCodigo}-${item.pdca_plano_id}`}
                        item={item}
                        nls={nls}
                        actions={obterAcoesPriorities(
                          item,
                          nls,
                          podeGerirProjeto,
                          handleAbrirRejeitar,
                          handleAbrirAprovarPlan,
                          handleAbrirAprovarDo
                        )}
                        onDetalhes={handleDetalhes}
                        onAgirAct={handleAgirAct}
                      />
                    ))}
                  </div>
                ) : (
                  <PdcaEmptyState title={nls.emptyState} />
                )}
              </>
            ) : null}
          </LoadingContent>
        ) : null}

        <Detalheplano
          open={detalheOpen}
          close={() => setDetalheOpen(false)}
          planoId={planoIdSelecionado}
        />

        <RejeitarPlano
          open={rejeitarOpen}
          close={handleFecharRejeitar}
          planoId={planoIdRejeitar}
          ciclo={cicloRejeitar}
          nomePlano={nomePlanoRejeitar}
          onSuccess={handleSucessoRejeitar}
        />

        <AprovarAcao
          open={aprovarOpen}
          close={handleFecharAprovar}
          planoId={planoIdAprovar}
          tipoPlano=''
          nivel=''
          nomePlano={nomePlanoAprovar}
          onSuccess={handleSucessoAprovar}
        />

        <Aprovarplanoplan
          open={aprovarPlanOpen}
          close={handleFecharAprovarPlan}
          planoId={planoIdAprovarPlan}
          onSuccess={handleSucessoAprovarPlan}
        />

        <Agiract
          open={agirActOpen}
          close={() => {
            setAgirActOpen(false)
            setPlanoIdAgirAct(null)
          }}
          planoId={planoIdAgirAct}
          onSuccess={handleSucessoAgirAct}
        />
      </div>
    </PdcaLayout>
  )
}